import { useState, useEffect } from 'react';
import {
  Button, Table, Space, Popconfirm, message,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import './index.less';
import { getDeclareList, cancelApplication } from '@/services/supplyChainFinance';

export default function Declaration() {
  const Navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { run: queryOrderList } = useRequest(getDeclareList, {
    manual: true,
    onSuccess(res) {
      setTableData(res?.items || []);
      setLoading(false);
    },
    onError() {
      setLoading(false);
      message.error('加载数据失败');
    },
  });

  const { run: cancelRun, loading: cancelLoading } = useRequest(cancelApplication, {
    manual: true,
    onSuccess() {
      message.success('取消申报成功');
      queryOrderList({ pageNum: 1, pageSize: 10 });
    },
    onError() {
      message.error('取消申报失败');
    },
  });

  // 初始化加载数据
  useEffect(() => {
    setLoading(true);
    queryOrderList({ pageNum: 1, pageSize: 10 });
  }, []);

  // 查看详情
  const handleDetail = (record) => {
    Navigate(`/supplyChain/detail?id=${record.id}&from=declaration`);
  };

  // 编辑
  const handleEdit = (record) => {
    Navigate(`/supplyChain/application?backId=${record.id}&type=${record.type}&billionAgriProjectId=${record.billionAgriProjectId}`);
  };

  // 重新申报
  const handleReDeclare = (record) => {
    Navigate(`/supplyChain/application?backId=${record.id}&type=${record.type}&billionAgriProjectId=${record.billionAgriProjectId}&reDeclare=true`);
  };

  // 取消申报
  const handleCancelConfirm = (id) => {
    cancelRun(id);
  };

  const columns = [
    {
      title: '项目名称',
      dataIndex: 'projectName',
      key: 'projectName',
      width: 400,
      ellipsis: true,
    },
    {
      title: '所属产业链',
      dataIndex: 'industryChainBelongs',
      key: 'industryChainBelongs',
      width: 120,
      ellipsis: true,
    },
    {
      title: '联系人',
      dataIndex: 'contactName',
      key: 'contactName',
      width: 120,
    },
    {
      title: '手机号',
      dataIndex: 'contactPhone',
      key: 'contactPhone',
      width: 130,
    },
    {
      title: '主体角色',
      dataIndex: 'mainRoleValue',
      key: 'mainRoleValue',
      width: 150,
      render: (text) => (text || '-'),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => {
        let statusText = '-';
        if (status === 0) {
          statusText = '已申报';
        } else if (status === 1) {
          statusText = '认证通过';
        } else if (status === 2) {
          statusText = '认证不通过';
        } else if (status === 10) {
          statusText = '部分认证通过';
        } else if (status === 11) {
          statusText = '确认中';
        } else if (status === 24) {
          statusText = '已取消';
        }
        return <span>{statusText}</span>;
      },
    },
    {
      title: '申报日期',
      dataIndex: 'gmtCreate',
      key: 'gmtCreate',
      width: 130,
    },
    {
      title: '操作',
      key: 'action',
      width: 200,
      fixed: 'right',
      render: (_, record) => (
        <Space size="small">
          <Button type="link" size="small" onClick={() => handleDetail(record)}>
            详情
          </Button>
          {[0, 1, 10, 11].includes(record.status) && (
            <Button type="link" size="small" onClick={() => handleEdit(record)}>
              编辑
            </Button>
          )}
          {[0, 11].includes(record.status) && (
            <Popconfirm
              title="确定要取消申报吗？"
              description="取消后无法恢复"
              onConfirm={() => handleCancelConfirm(record.id)}
              okText="确定"
              cancelText="取消"
            >
              <Button type="link" danger size="small" loading={cancelLoading}>
                取消申报
              </Button>
            </Popconfirm>
          )}
          {record.status === 2 && (
            <Button type="link" size="small" onClick={() => handleReDeclare(record)}>
              重新申报
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className="supply-chain-finance__declaration">
      {/* <div className="supply-chain-finance__banner">
        产业链金融
      </div> */}
      <div className="content-width">
        <div className="supply-chain-finance__info-title">申报信息</div>
        <div className="margin-top20">
          <Table
            columns={columns}
            dataSource={tableData}
            loading={loading}
            rowKey="id"
            scroll={{ x: 1200 }}
            pagination={{
              pageSize: 10,
              total: tableData.length,
              showTotal: (total) => `共 ${total} 条`,
            }}
          />
        </div>
      </div>
    </div>
  );
}
